<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Login Left-->
      <b-col
        xl="5"
        class="d-flex align-items-center flex-column auth-bg px-2 py-3 p-md-1 p-lg-2 p-xl-2 h-100"
      >
        <div class="auth-locale">
          <locale />
        </div>
        <!-- Brand logo-->
        <b-link class="brand-logo-login">
          <b-img
            :src="appLogoImage"
            width="140"
          />
        </b-link>
        <!-- /Brand logo-->

        <b-col
          v-if="!formSent"
          xs="12"
          sm="10"
          md="6"
          lg="5"
          xl="12"
          class="px-xl-4 flex-12-none"
        >
          <h2 class="text-center">
            {{ $t('Boho | Female Host Application') }}
          </h2>
          <p class="text-center">
            {{ $t('Please type down the information required from you. We intend to have these answers for putting you in the best position.') }}
          </p>
          <div>
            <validation-observer
              ref="form"
              #default="{invalid}"
            >
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent="send"
              >
                <b-form-group
                  label-for="email"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Email')"
                    vid="email"
                    rules="required"
                  >
                    <label for="email" class="text-dark">
                      {{ $t('Email') }}
                    </label>
                    <b-form-input
                      id="email"
                      v-model="email"
                      name="email"
                      :placeholder="$t('Email')"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-for="experience"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Experience')"
                    vid="experience"
                    rules="required"
                  >
                    <label for="experience" class="text-dark">
                      {{ $t('Do you have experience on a 1v1 voice and video call apps like Boho before? If yes, please specify which app. If no, you can just type "no".') }}
                    </label>
                    <b-form-input
                      id="experience"
                      v-model="experience"
                      name="experience"
                      :placeholder="$t('Experience')"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-for="availability"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Availability')"
                    vid="availability"
                    rules="required"
                  >
                    <label for="experience" class="text-dark">
                      {{ $t('Are you currently available on being connected (online) on Boho for minimum two hours a day?') }}
                    </label>
                    <div class="d-flex gap-6">
                      <b-form-checkbox
                        v-model="availability"
                        class="custom-control-dark"
                        switch
                        button-variant="primary"
                        :disabled="loading"
                      />
                      <span :class="availability ? 'green-text' : 'red-text'">
                        {{ availability ? $t('Yes') : $t('No') }}
                      </span>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-for="english_level"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('English Level')"
                    vid="english_level"
                    rules="required"
                  >
                    <label for="english_level" class="text-dark">
                      {{ $t('What is your level of English?') }}
                    </label>
                    <b-form-radio
                      v-model="englishLevel"
                      name="english_level"
                      :value="$t('Beginner/Elementary')"
                    >
                      {{ $t('Beginner/Elementary') }}
                    </b-form-radio>
                    <b-form-radio
                      v-model="englishLevel"
                      name="english_level"
                      :value="$t('Intermediate')"
                    >
                      {{ $t('Intermediate') }}
                    </b-form-radio>
                    <b-form-radio
                      v-model="englishLevel"
                      name="english_level"
                      :value="$t('Native or Bilingual')"
                    >
                      {{ $t('Native or Bilingual') }}
                    </b-form-radio>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-for="phone_number"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Phone number')"
                    vid="phone_number"
                    rules="required"
                  >
                    <label for="experience" class="text-dark">
                      {{ $t('Phone number') }}
                    </label>
                    <b-form-input
                      id="phone_number"
                      ref="phoneInput"
                      v-model="phoneNumber"
                      type="tel"
                      name="experience"
                      :placeholder="$t('Phone number')"
                      :state="errors.length > 0 ? false:null"
                      @input="handleInput"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  class="mt-2"
                  label-for="contact_details"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Contact details')"
                    vid="contact_details"
                    rules="required"
                  >
                    <label for="contact_details" class="text-dark">
                      {{ $t('Please drop your Whatsapp or Telegram contact details here') }}
                    </label>
                    <p class="fs-12">
                      ({{ $t("It's needed for our global responsible to reach out to you for giving you further details about the position") }}.)
                    </p>
                    <b-form-textarea
                      id="contact_details"
                      v-model="contactDetails"
                      :disabled="loading"
                      :placeholder="$t('Contact details')"
                      max-rows="6"
                      rows="3"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-button
                  class="mt-2"
                  type="submit"
                  variant="primary"
                  block
                  :disabled="loading || invalid"
                >
                  <b-spinner
                    v-if="loading"
                    small
                  />
                  {{ $t('Send') }}
                </b-button>
              </b-form>
            </validation-observer>
          </div>
        </b-col>

        <b-col
          v-else
          xs="12"
          sm="10"
          md="6"
          lg="5"
          xl="12"
          class="px-xl-4 flex-12-none mt-5"
        >
          <h1 class="text-center">
            {{ $t('Your information has been received. You will be contacted as soon as possible. Thank you for your time.') }}
          </h1>
        </b-col>
      </b-col>
      <!-- /Login Left-->

      <!-- Right Text-->
      <b-col
        xl="7"
        class="d-none d-xl-flex align-items-center login-right"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <b-img
            fluid
            :src="sideImg"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Right Text-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BImg,
  BForm,
  BFormCheckbox,
  BFormInput,
  BFormTextarea,
  BButton,
  BFormGroup,
  BSpinner,
  BFormRadioGroup, BFormRadio,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import useJwt from '@/auth/jwt/useJwt'
import { throwDefaultError, showNotify } from '@/helpers/helpers'

import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

const { appLogoImage } = $themeConfig.app
const sideImg = require('@/assets/images/auth/login-bg.svg')

export default {
  components: {
    BFormRadio,
    BFormRadioGroup,
    BButton,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BImg,
    BLink,
    BRow,
    BSpinner,

    Locale,

    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      appLogoImage: appLogoImage,
      availability: true,
      contactDetails: '',
      email: '',
      englishLevel: '',
      experience: '',
      formSent: false,
      iti: null,
      loading: false,
      phoneNumber: '',
      formattedPhoneNumber: '',
      sideImg,
    }
  },
  watch: {
    '$i18n.locale'(newLocale) {
      // Dil değiştiğinde tel input'u yeniden oluştur
      if (this.iti) {
        this.iti.destroy();
        this.initializeTelInput(newLocale);
      }
    }
  },
  created() {},
  mounted() {
    // intl-tel-input'u başlat
    this.initializeTelInput(this.$i18n.locale);

    // input değeri varsa set et
    if (this.phoneNumber) {
      this.iti.setNumber(this.phoneNumber);
    }

    // Sayfa yeniden yüklendiğinde veya component destroy olduğunda
    // intl-tel-input instance'ını temizle
    window.addEventListener('unload', () => {
      if (this.iti) {
        this.iti.destroy();
      }
    });
  },
  beforeDestroy() {
    if (this.iti) {
      this.iti.destroy();
    }
  },
  methods: {
    handleInput() {
      if (!this.iti) return;

      // Tam telefon numarasını al (ülke kodu dahil)
      const number = this.iti.getNumber();

      // Numaranın geçerli olup olmadığını kontrol et
      const isValid = this.iti.isValidNumber();

      // Seçili ülke bilgilerini al
      const countryData = this.iti.getSelectedCountryData();

      this.formattedPhoneNumber = `+${countryData.dialCode}${this.phoneNumber}`;
    },
    initializeTelInput(locale) {
      const inputElement = this.$refs.phoneInput.$el || this.$refs.phoneInput;
      this.iti = intlTelInput(inputElement, {
        initialCountry: 'auto',
        geoIpLookup: function(callback) {
          // Tarayıcının navigator.language'inden ülke kodunu al
          const countryCode = navigator.language.split('-')[1] || 'TR';
          callback(countryCode);
        },
        separateDialCode: true,
        utilsScript: '../../../node_modules/intl-tel-input/build/js/utils.js',
        i18n: {
          search: this.$t('Search'),
          searchPlaceholder: this.$t('Search'),
          title: this.$t('Select Country')
        },
        language: locale
      });
    },
    send() {
      this.loading = true

      const data = {
        email: this.email,
        experience: this.experience,
        availability: this.availability ? 'Yes' : 'No',
        english_level: this.englishLevel,
        phone_number: this.formattedPhoneNumber,
        contact_details: this.contactDetails,
      }

      useJwt.postFemaleHostApplications(data)
          .then(response => {
            showNotify(this.$toast, this.$t('Your message has been sent'), 'success')
            this.formSent = true
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style>
.iti {
  width: 100%;
}
</style>
